import { NgModule } from '@angular/core';

import { PaymentEntryStatusComponent } from './payment-entry-status.component';
import { CommonModule } from '@nano/common';

@NgModule({
  declarations: [PaymentEntryStatusComponent],
  imports: [CommonModule],
  exports: [PaymentEntryStatusComponent]
})
export class PaymentEntryStatusModule {}
